import React from "react";
import { NextPage } from "next";
import UploadMusicRoot from "../../modules/UploadMusic/UploadMusicRoot";
import ProtectedPage from "../../common/components/PageWrappers/ProtectedPage";

const UploadMusicPage: NextPage = () => (
  <ProtectedPage>
    <UploadMusicRoot />
  </ProtectedPage>
);

export default UploadMusicPage;
